import axios from 'app/axiosInstance'

export const getLang = () => {
    return axios().get('v1/languages/_search')
}
